import { CustomError } from './CustomError';

/**
 * Extrai a mensagem de erro de forma consistente, tratando diferentes formatos de erro.
 * Prioriza a mensagem da API (ex: "Usuário já cadastrado") quando disponível.
 */
export function getErrorMessage(error: unknown, fallback = 'Ocorreu um erro. Tente novamente.'): string {
  if (error instanceof CustomError || error instanceof Error) {
    return error.message || fallback;
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const msg = (error as { message?: unknown }).message;
    if (typeof msg === 'string') return msg;
  }
  return fallback;
}
